// extracted by mini-css-extract-plugin
module.exports = {"Certification":"CertificationBanner_Certification__8BERJ"};